import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=2bf97c5c"
import script from "./DailyChallenge.vue?vue&type=script&lang=js"
export * from "./DailyChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports